<app-document-countries
  [name]="'Правила оплаты и безопасность платежей'"
  [countries]="countries"
></app-document-countries>
